import React, { Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import ClientActions from '../../../store/clientRedux';

import Skeleton from '../../../components/library/loaders/Skeleton';
import PurchaseYearSection from './PurchaseYearSection';
import EmptyPurchaseHistory from './EmptyPurchaseHistory';

const PurchaseHistory = () => {
    const dispatch = useDispatch();

    const { id } = useParams();

    var products = useSelector(state => state.client.selectedClient.purchasedProducts)
    products = products?.filter(p => !p.isDeleted)

    useEffect(() => {
        if (id) {
            dispatch(ClientActions.getDiyReturns(id));
        }
    }, [id]);

    const getYears = () => {
        var years = [];
        for (var i = new Date().getFullYear(); i >= 2016; i--) {
            years.push(i);
        }
        return years;
    }

    
    return (
        <Fragment>
            {!products && 
                <Skeleton />
            }
            {products && products.length === 0 &&
                <EmptyPurchaseHistory />
            }
            {products && products.length > 0 &&
                getYears().map(y =>
                    <PurchaseYearSection
                        key={`pys_${y}`}
                        taxYear={y}
                        clientId={id}
                        returns={products.filter(r => r && r.taxYear === y) || []} />)
            }
        </Fragment>
    );
}

export default PurchaseHistory;